var exports = {
  "Fc": "placementsBackground__Q2FtW",
  "lc": "placementsButton__Q2FtW",
  "kN": "placementsContainer__Q2FtW",
  "$M": "placementsLayout__Q2FtW",
  "rU": "rightElement__Q2FtW",
  "gx": "topLeftContainer__Q2FtW",
  "BE": "topRightContainer__Q2FtW",
  "FU": "topSectionLayout__Q2FtW",
};

module.exports = exports;
